module.exports = __webpack_public_path__ + "static/media/contact1.684f9bf6.jpg";